"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLandPolygon = exports.getLandsBySect = exports.getLandByHodAndSectAndCharacters = exports.getSectByHod = exports.getSectByHodAndCharacters = void 0;
var tslib_1 = require("tslib");
var graphql_tag_1 = require("graphql-tag");
function getSectByHodAndCharacters(_a) {
    var hodId = _a.hodId, chars = _a.chars, landsVersion = _a.landsVersion, take = _a.take;
    var where = {
        version: { equals: landsVersion },
        Hod: {
            is: {
                id: {
                    equals: hodId,
                },
            },
        },
        OR: [{ sectNameAr: { contains: chars } }, { sectId: { contains: chars } }],
    };
    // where.sectNameAr = { contains: chars };
    var variables = {
        where: where,
        take: take || 100,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n      query($where: LandsWhereInput, $take: Int) {\n        lands(where: $where, distinct: sectId, take: $take) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          dlsKey\n          Hod {\n            id\n            nameAr\n          }\n          version\n        }\n      }\n    "], ["\n      query($where: LandsWhereInput, $take: Int) {\n        lands(where: $where, distinct: sectId, take: $take) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          dlsKey\n          Hod {\n            id\n            nameAr\n          }\n          version\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getSectByHodAndCharacters = getSectByHodAndCharacters;
function getSectByHod(_a) {
    var hodId = _a.hodId, landsVersion = _a.landsVersion, orderBy = _a.orderBy, take = _a.take;
    return {
        variables: {
            where: {
                version: {
                    equals: landsVersion,
                },
                Hod: {
                    is: {
                        id: {
                            equals: hodId,
                        },
                    },
                },
            },
            orderBy: orderBy,
            take: take || 100,
        },
        query: (0, graphql_tag_1.default)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: LandsWhereInput!\n        $orderBy: [LandsOrderByInput!]\n        $take: Int\n      ) {\n        lands(where: $where, orderBy: $orderBy, take: $take, distinct: sectId) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          dlsKey\n          Hod {\n            id\n            nameAr\n          }\n        }\n      }\n    "], ["\n      query(\n        $where: LandsWhereInput!\n        $orderBy: [LandsOrderByInput!]\n        $take: Int\n      ) {\n        lands(where: $where, orderBy: $orderBy, take: $take, distinct: sectId) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          dlsKey\n          Hod {\n            id\n            nameAr\n          }\n        }\n      }\n    "]))),
    };
}
exports.getSectByHod = getSectByHod;
function getLandByHodAndSectAndCharacters(_a) {
    var hodId = _a.hodId, sectId = _a.sectId, chars = _a.chars, landsVersion = _a.landsVersion, take = _a.take, skip = _a.skip;
    var where = {
        version: { equals: landsVersion },
        Hod: {
            is: {
                id: {
                    equals: hodId,
                },
            },
        },
        sectId: { equals: sectId },
    };
    where.landKey = { contains: chars };
    var variables = {
        where: where,
        take: take || 100,
        skip: skip || 0,
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      query($where: LandsWhereInput, $take: Int, $skip: Int) {\n        lands(where: $where, take: $take, skip: $skip) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          landKey\n          dlsKey\n          lat\n          lng\n          zoom\n          Hod {\n            id\n            nameAr\n          }\n          version\n        }\n        landsConnection(where: $where) {\n          _count {\n            id\n          }\n        }\n      }\n    "], ["\n      query($where: LandsWhereInput, $take: Int, $skip: Int) {\n        lands(where: $where, take: $take, skip: $skip) {\n          id\n          sectId\n          sectNameAr\n          sectNameEn\n          landKey\n          dlsKey\n          lat\n          lng\n          zoom\n          Hod {\n            id\n            nameAr\n          }\n          version\n        }\n        landsConnection(where: $where) {\n          _count {\n            id\n          }\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getLandByHodAndSectAndCharacters = getLandByHodAndSectAndCharacters;
function getLandsBySect(_a) {
    var hodId = _a.hodId, LandsVersion = _a.LandsVersion, orderBy = _a.orderBy, take = _a.take, sectId = _a.sectId;
    return {
        variables: {
            where: {
                version: {
                    equals: LandsVersion,
                },
                Hod: {
                    is: {
                        id: {
                            equals: hodId,
                        },
                    },
                },
                sectId: { equals: sectId },
            },
            orderBy: orderBy,
            take: take || 100,
        },
        query: (0, graphql_tag_1.default)(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      query(\n        $where: LandsWhereInput!\n        $orderBy: [LandsOrderByInput!]\n        $take: Int\n      ) {\n        lands(where: $where, orderBy: $orderBy, take: $take) {\n          id\n          sectId\n          sectNameAr\n          landKey\n          dlsKey\n          lat\n          lng\n          zoom\n          Hod {\n            id\n            nameAr\n          }\n        }\n      }\n    "], ["\n      query(\n        $where: LandsWhereInput!\n        $orderBy: [LandsOrderByInput!]\n        $take: Int\n      ) {\n        lands(where: $where, orderBy: $orderBy, take: $take) {\n          id\n          sectId\n          sectNameAr\n          landKey\n          dlsKey\n          lat\n          lng\n          zoom\n          Hod {\n            id\n            nameAr\n          }\n        }\n      }\n    "]))),
    };
}
exports.getLandsBySect = getLandsBySect;
function getLandPolygon(_a) {
    var id = _a.id;
    var variables = {
        where: {
            id: {
                equals: id,
            },
        },
    };
    return {
        query: (0, graphql_tag_1.default)(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n      query Lands($where: LandsWhereInput) {\n        lands(where: $where) {\n          id\n          polygon\n        }\n      }\n    "], ["\n      query Lands($where: LandsWhereInput) {\n        lands(where: $where) {\n          id\n          polygon\n        }\n      }\n    "]))),
        variables: variables,
    };
}
exports.getLandPolygon = getLandPolygon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
